import React from "react";

const Billing = () => {
  return <div></div>;
};

export default Billing;
